import gql from 'graphql-tag';

export default class MeetingFragments {
  static meeting = gql`
    fragment meetingFragment on Meeting {
      id
      entityId
      dealroomId
      participantId
      title
      status
      attendees {
        email
        participantId
        firstName
        lastName
        companyName
        title
        phone
      }
      createdAt
      updatedAt
      date
      summary
      nextSteps
      externalId
      externalSource
      video {
        ... on ExternalMeetingVideo {
          type
          videoUrl
        }
        ... on InternalMeetingVideo {
          type
          videoId
        }
      }
    }
  `;
}
